import '../App.css';
import '../style.css';
import '../font.css';
import './style_works.css';
import OpenButton from '../components/OpenButton';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';

export function WorkTitle(props: {
    title: string;
    description: React.ReactNode;
    team: string;
    role: string;
    period: string;
    showButton?: boolean;
    buttonLabel?: string;
    buttonHref?: string;
    // 수동 번역(한국어) 전달용 선택적 프로퍼티들
    titleKo?: string;
    descriptionKo?: React.ReactNode;
    teamKo?: string;
    roleKo?: string;
}) {
    const { language } = useLanguage();
    // 기존 훅은 다른 언어 케이스 호환을 위해 유지하되, ko에서는 수동 번역 우선 사용
    const titleTranslation = useTranslation(props.title);
    const teamTranslation = useTranslation(props.team);
    const roleTranslation = useTranslation(props.role);
    const descriptionTranslation = useTranslation(typeof props.description === 'string' ? props.description : '');

    return (
        <div className="work-title-container" style={{margin: "auto", maxWidth: "1400px", display: "flex", alignContent: "center", flexDirection:"row", padding: "80px 48px", gap:'60px', justifyContent: "space-between"}}> 
         <div className="work-title-content" style={{ display: "flex", flexDirection:"column", gap: "72px"}}> 
                <div className="work-title-header" style={{display: "flex", flexDirection:"column", gap: "14px"}}>
                    <div className="work-title-text"
                        style = {{
                            color: "var(--color-text-primary)",
                            fontFamily: "Montserrat",
                            fontSize: "54px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "normal",
                            letterSpacing : "-1px"
                        }}>{language === 'ko' ? (props.titleKo ?? titleTranslation.translatedText) : titleTranslation.translatedText}</div>
                    <div className="work-title-description" style = {{
                            color: "var(--color-text-quaternary)",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "130%",
                            letterSpacing : "0.5px"
                        }}>
                        {language === 'ko'
                          ? (props.descriptionKo ?? (typeof props.description === 'string' ? descriptionTranslation.translatedText : props.description))
                          : (typeof props.description === 'string' ? descriptionTranslation.translatedText : props.description)}
                    </div>
                    </div>
                <div className="work-title-meta" style = {{display: "flex", flexDirection:"row", gap: "100px" }}>
                    <div className="work-title-meta-item" style={{display: "flex", flexDirection:"column", gap: "8px"}}>
                        <div style = {{
                                color: "var(--color-text-primary)",
                               
                                fontStyle: "normal",
                                fontWeight: "700"
                        }}>Team</div> 
                        <div style = {{
                                color: "var(--color-text-quaternary)",
                                
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "151.8%"
                        }}>{language === 'ko' ? (props.teamKo ?? teamTranslation.translatedText) : teamTranslation.translatedText}</div>
                    </div>
                    <div className="work-title-meta-item" style={{display: "flex", flexDirection:"column", gap: "8px"}}>
                        <div style = {{
                                color: "var(--color-text-primary)",
                                
                                fontStyle: "normal",
                                fontWeight: "700"
                        }}>Role</div> 
                        <div style = {{
                                color: "var(--color-text-quaternary)",
                                
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "151.8%"
                        }}>{language === 'ko' ? (props.roleKo ?? roleTranslation.translatedText) : roleTranslation.translatedText}</div>
                    </div>
                    <div className="work-title-meta-item" style={{display: "flex", flexDirection:"column", gap: "8px"}}>
                        <div style = {{
                                color: "var(--color-text-primary)",
                              
                                fontStyle: "normal",
                                fontWeight: "700"
                        }}>Peroid</div> 
                        <div style = {{
                                color: "var(--color-text-quaternary)",
                                
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "151.8%"
                        }}>{props.period}</div>
                    </div>
                </div>
                
            </div>
            <div>{props.showButton && props.buttonLabel && props.buttonHref && (
                    <OpenButton label={props.buttonLabel} href={props.buttonHref} />
                 )}</div>
        </div>
    )
}
